import { useState, useEffect } from "react";
//API
import { axiosWithAuth } from "../../../../api/axiosConfig";
import {
  urlGetTyresSize,
  urlCreateTyresSize,
  urlEditTyresSize,
} from "../../../../api/URLs/cubiertas";
//HOOKS
import { useModal } from "../../../../hooks/useModal";
//FORMIK & YUP
import { Formik } from "formik";
import { tyresSizeSchema } from "../../../../schemas/Cubiertas/tyresSizeSchema";
//BOOTSTRAP
import { Button, Form, FormGroup } from "react-bootstrap";
//COMPONENTS
//--Modal
import ModalAlert from "../../../../components/Modals/ModalAlert";
//--Table
import Table from "../../../../components/Tools/Tables/Table/Table";
//--Basic
import BoxContainer from "../../../../components/Tools/Cards/BoxContainer/BoxContainer";
import CenterSpinner from "../../../../components/Tools/Basics/Spinner";
import CustomBtn from "../../../../components/Tools/Basics/CustomBtn";

const FormTyreSize = () => {
  //useModal
  const {
    showModal,
    modalType,
    msjModal,
    handleClose,
    handleError,
    handleSucces,
  } = useModal();
  //States
  const [reForm, setReForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [tyreSize, setTyreSize] = useState(null);
  const [tyresSize, setTyresSize] = useState([]);
  //INITIAL VALUES
  let newValues, updateValues;
  if (tyreSize) {
    updateValues = {
      medida: tyreSize.medida ? tyreSize.medida : "",
    };
  } else {
    newValues = {
      medida: "",
    };
  }
  const initialValues = tyreSize ? updateValues : newValues;
  //GET
  const getTyresSize = async () => {
    try {
      setLoadingTable(true);
      const api_response = await axiosWithAuth.get(urlGetTyresSize);
      setTyresSize(api_response.data);
    } catch (error) {
      const auxError = error.response.data.msj
        ? error.response.data.msj
        : "Error del servidor";
      handleError(auxError);
    } finally {
      setLoadingTable(false);
    }
  };
  //POST - PUT
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      let api_response;
      if (tyreSize) {
        api_response = await axiosWithAuth.put(urlEditTyresSize, {
          ...values,
          id: tyreSize.id,
        });
      } else {
        api_response = await axiosWithAuth.post(urlCreateTyresSize, values);
      }
      handleSucces(api_response);
      setReForm(!reForm);
    } catch (error) {
      const auxError = error.response.data.msj
        ? error.response.data.msj
        : "Error del servidor";
      handleError(auxError);
    } finally {
      setLoading(false);
      setTyreSize(null);
    }
  };
  //HANDLE EDIT
  const handleEdit = async (t) => {
    setTyreSize(t);
    setReForm(!reForm);
  };
  //BOTONES
  const actions = (t) => {
    return <CustomBtn type={"edit_table"} onClick={() => handleEdit(t)} />;
  };
  //COLUMNAS
  const columns = [
    { header: "Id", field: "id" },
    { header: "Medida", field: "medida" },
    { header: "Editar", body: actions },
  ];
  useEffect(() => {
    getTyresSize();
  }, [reForm]);
  return (
    <div className="row">
      <div className="col-md-8">
        <BoxContainer maxSize={"lg"} minSize={"lg"}>
          <Table
            data={tyresSize}
            columns={columns}
            keyProp={"id"}
            title={"Medidas de Cubiertas"}
            scrollSize={"lg"}
            textFilter
            loading={loadingTable}
          />
        </BoxContainer>
      </div>
      <div className="col-md-4">
        {!loading ? (
          <>
            <div
              className={`alert alert-${
                tyreSize ? "success" : "primary"
              } w-100`}
              role="alert"
            >
              {`${tyreSize ? "Modificar" : "Añadir nueva"} medida ${
                tyreSize ? tyreSize.medida : ""
              }`}
            </div>
            <Formik
              enableReinitialize
              validationSchema={tyresSizeSchema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                errors,
                touched,
                isSubmitting,
              }) => (
                <Form onSubmit={handleSubmit} className="shadow-none mb-2">
                  {/* MARCA */}
                  <FormGroup>
                    <Form.Control
                      type="text"
                      placeholder="Ingresar"
                      name="medida"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.medida}
                      isInvalid={
                        errors.medida && touched.medida && errors.medida
                      }
                    />
                  </FormGroup>
                  <Button
                    variant={tyreSize ? "success" : "primary"}
                    className="mt-3 w-100"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {tyreSize ? "Modificar" : "Agregar"}
                  </Button>
                </Form>
              )}
            </Formik>
          </>
        ) : (
          <CenterSpinner />
        )}
      </div>
      <ModalAlert
        show={showModal}
        type={modalType}
        msj={msjModal}
        handleClose={handleClose}
      />
    </div>
  );
};

export default FormTyreSize;
